import { Alert, Loader } from "@fluentui/react-northstar";
import { Elements } from "@stripe/react-stripe-js";
import { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import React, { useEffect, useRef, useState } from "react";

import { clientEventTracker } from "../../utils/clientTelemetry";
import { getStripeKey } from "../../utils/teamsHelpers";

export const StripeForm: React.FC = ({ children }) => {
  const stripeRef = useRef<Stripe | null>(null);
  const [loaded, setLoaded] = useState<boolean>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    (async () => {
      setLoaded(false);

      try {
        stripeRef.current = await loadStripe(getStripeKey());
        setLoaded(true);
      } catch (error) {
        clientEventTracker.trackFatalError(
          "error_boundary",
          { userId: "", tenantId: "" },
          { error }
        );
        setError((error as Error).message);
      }
    })();
  }, []);

  if (error) {
    return <Alert danger content={`Error please contact support or try again: {error}`} />;
  }

  if (!loaded) {
    return <Loader label="Loading..." labelPosition="above" />;
  }

  return <Elements stripe={stripeRef.current}>{children}</Elements>;
};
